"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@mui/styles");
var useStyles = exports.useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: "100vh",
      width: "100vw",
      display: "flex",
      justifyContent: "center",
      backgroundColor: theme.palette.primary.main
    },
    paper: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      minWidth: "25%",
      marginTop: "10%",
      borderRadius: 12
    },
    contentContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: theme.spacing(2),
      minWidth: 300
    },
    textWhite: {
      color: theme.palette.common.white
    },
    form: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "80%",
      marginTop: theme.spacing(3)
    },
    input: {
      color: theme.palette.common.white,
      background: "rgba(255,255,255,.1)",
      height: 50
    },
    inputFocused: {
      borderColor: theme.palette.common.white
    },
    inputPlaceholder: {
      borderWidth: 0,
      fontWeight: 500
    },
    submit: {
      margin: theme.spacing(5, 0, 2)
    },
    validationError: {
      color: theme.palette.warning.dark
    },
    error: {
      width: "100%",
      marginTop: "1rem",
      paddingLeft: ".5rem",
      color: theme.palette.warning.dark
    },
    fieldContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "22rem",
      marginBottom: theme.spacing(1)
    },
    accountSection: {
      display: "flex",
      width: "75%",
      justifyContent: "space-evenly"
    },
    checkbox: {
      padding: "0 .8rem 0 0"
    },
    row: {
      width: "100%"
    },
    buttonContainer: {
      display: "flex",
      height: "6rem",
      flexDirection: "column",
      justifyContent: "space-between"
    },
    button: {
      background: theme.palette.common.white,
      color: theme.palette.primary.dark,
      borderRadius: 20,
      "&:hover": {
        color: theme.palette.common.white
      }
    },
    footer: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      paddingRight: ".5rem",
      marginTop: theme.spacing(1)
    }
  };
});